import { type Tier, scaledRating } from '@topmeeps/shared'

const TIER_COLOR: Record<Tier, string> = {
  layperson: 'var(--tier-layperson)',
  novice: 'var(--tier-novice)',
  pupil: 'var(--tier-pupil)',
  student: 'var(--tier-student)',
  scholar: 'var(--tier-scholar)',
  philosopher: 'var(--tier-philosopher)',
  sage: 'var(--tier-sage)',
}

export type TierBadgeProps = {
  tier: Tier | null
  // Raw μ. The badge applies cosmetic display scaling internally so
  // callers don't have to think about it.
  score?: number | null
  compact?: boolean
}

export const TierBadge = ({ tier, score, compact }: TierBadgeProps) => {
  const displayScore = typeof score === 'number' ? scaledRating(score) : null

  // Provisional: the dashed border and muted ink carry the meaning —
  // no "provisional" text needed.
  if (tier === null) {
    return (
      <span
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          fontFamily: 'var(--font-mono)',
          fontWeight: 500,
          fontSize: 11,
          color: 'var(--ink-3)',
          border: '1px dashed var(--line)',
          borderRadius: 3,
          padding: compact ? '1px 5px' : '2px 6px',
        }}
      >
        {displayScore ?? '—'}
      </span>
    )
  }

  // Rated: the border colour and the small diamond carry the tier —
  // no tier name needed.
  const color = TIER_COLOR[tier]
  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 5,
        fontFamily: 'var(--font-mono)',
        fontWeight: 500,
        fontSize: 11,
        color: 'var(--ink-2)',
        background: '#fff8ea',
        border: `1.5px solid ${color}`,
        borderRadius: 3,
        padding: compact ? '1px 5px' : '2px 7px',
        boxShadow: `inset 0 -2px 0 ${color}30`,
      }}
    >
      <span
        style={{
          width: 6,
          height: 6,
          background: color,
          transform: 'rotate(45deg)',
          display: 'inline-block',
        }}
      />
      {displayScore ?? '—'}
    </span>
  )
}
